(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-infographic-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('asc-shared-guides')) {
    customElements.define('asc-shared-guides', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        this.track = this.querySelector('[data-sg-track]');
        this.rail = this.querySelector('[data-sg-rail]');
        this.cards = Array.from(this.querySelectorAll('[data-sg-card]'));
        this.dialog = this.querySelector('[data-sg-dialog]');
        this.viewerImage = this.querySelector('[data-sg-viewer-image]');
        this.viewport = this.querySelector('[data-sg-viewport]');
        this.zoomButton = this.querySelector('[data-sg-zoom]');
        this.previous = this.querySelector('[data-sg-prev]');
        this.next = this.querySelector('[data-sg-next]');
        this.gridToggle = this.querySelector('[data-sg-toggle-grid]');
        if (!this.track || !this.cards.length) return;
        const on = (target, event, callback) => target.addEventListener(event, callback, { signal: this.abort.signal });
        this.gridToggle.hidden = this.cards.length < 2;
        on(this.gridToggle, 'click', () => {
          const expanded = this.classList.toggle('sg--grid');
          this.gridToggle.setAttribute('aria-expanded', String(expanded));
          this.gridToggle.textContent = expanded ? this.gridToggle.dataset.closeLabel : this.gridToggle.dataset.openLabel;
          this.track.scrollTo({ left: 0, behavior: 'instant' });
          this.update();
        });
        on(this.previous, 'click', () => this.move(-1));
        on(this.next, 'click', () => this.move(1));
        on(this.track, 'scroll', () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.update(), 120);
        });
        on(this.track, 'keydown', (event) => {
          if (event.target !== this.track || this.classList.contains('sg--grid')) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth * (rtl ? -1 : 1), behavior: this.motion() });
          }
        });
        this.cards.forEach((card, index) => {
          const anchor = card.querySelector('[data-sg-enlarge]');
          const image = card.querySelector('img');
          const showError = () => {
            image.hidden = true;
            card.querySelector('[data-sg-image-error]').hidden = false;
          };
          on(image, 'error', showError);
          if (image.complete && image.naturalWidth === 0) showError();
          if (typeof this.dialog.showModal === 'function') {
            anchor.setAttribute('aria-haspopup', 'dialog');
            on(anchor, 'click', (event) => {
              if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
              event.preventDefault();
              this.opener = anchor;
              this.showGuide(index);
              this.dialog.showModal();
            });
          }
        });
        on(this.querySelector('[data-sg-close]'), 'click', () => this.dialog.close());
        on(this.dialog, 'close', () => {
          this.resetZoom();
          this.viewerImage.removeAttribute('src');
          if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        });
        on(this.dialog, 'click', (event) => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        });
        on(this.querySelector('[data-sg-viewer-prev]'), 'click', () => this.showGuide(this.active - 1));
        on(this.querySelector('[data-sg-viewer-next]'), 'click', () => this.showGuide(this.active + 1));
        on(this.zoomButton, 'click', () => {
          const zoomed = this.viewport.classList.toggle('is-zoomed');
          this.zoomButton.setAttribute('aria-pressed', String(zoomed));
          if (zoomed) this.viewport.focus({ preventScroll: true });
        });
        on(this.viewerImage, 'load', () => this.viewerImage.style.setProperty('--sg-natural-width', `${this.viewerImage.naturalWidth}px`));
        on(this.viewerImage, 'error', () => {
          if (!this.viewerImage.hasAttribute('src')) return;
          this.viewerImage.hidden = true;
          this.querySelector('[data-sg-viewer-error]').hidden = false;
          this.zoomButton.disabled = true;
        });
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        clearTimeout(this.scrollTimer);
        this.resize?.disconnect();
        this.abort?.abort();
        this.abort = null;
        if (this.dialog?.open) this.dialog.close();
      }
      motion() {
        return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      }
      move(direction) {
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (this.cards[0].getBoundingClientRect().width + gap) * (rtl ? -1 : 1), behavior: this.motion() });
      }
      update() {
        const bounds = this.track.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const first = this.cards[0].getBoundingClientRect();
        const last = this.cards[this.cards.length - 1].getBoundingClientRect();
        this.previous.disabled = rtl ? first.right <= bounds.right + 4 : first.left >= bounds.left - 4;
        this.next.disabled = rtl ? last.left >= bounds.left - 4 : last.right <= bounds.right + 4;
        const showNavigation = !this.classList.contains('sg--grid') && this.track.scrollWidth > this.track.clientWidth + 4;
        this.querySelector('[data-sg-controls]').hidden = !showNavigation;
        this.previous.hidden = !showNavigation;
        this.next.hidden = !showNavigation;
        this.rail.classList.toggle('has-navigation', showNavigation);
        const visible = this.cards.map((card, index) => {
          const box = card.getBoundingClientRect();
          const intersection = Math.max(0, Math.min(box.right, bounds.right) - Math.max(box.left, bounds.left));
          return intersection >= box.width * 0.5 ? index + 1 : null;
        }).filter(Boolean);
        if (visible.length) this.querySelector('[data-sg-count]').textContent = this.dataset.rangeLabel
          .replace('FIRST', visible[0]).replace('LAST', visible[visible.length - 1]).replace('TOTAL', this.cards.length);
      }
      resetZoom() {
        this.viewport.classList.remove('is-zoomed');
        this.zoomButton.setAttribute('aria-pressed', 'false');
        this.viewport.scrollTo(0, 0);
      }
      showGuide(index) {
        if (index < 0 || index >= this.cards.length) return;
        this.active = index;
        this.resetZoom();
        const card = this.cards[index];
        const source = card.querySelector('img');
        const title = card.querySelector('[data-sg-title]')?.textContent || card.querySelector('[data-sg-enlarge]').dataset.title;
        const imageUrl = card.querySelector('[data-sg-enlarge]').href;
        this.querySelector('[data-sg-dialog-title]').textContent = title;
        this.viewerImage.hidden = false;
        this.querySelector('[data-sg-viewer-error]').hidden = true;
        this.zoomButton.disabled = false;
        this.viewerImage.alt = source.alt;
        this.viewerImage.width = Number(source.getAttribute('width'));
        this.viewerImage.height = Number(source.getAttribute('height'));
        this.viewerImage.src = imageUrl;
        this.querySelector('[data-sg-original]').href = imageUrl;
        const description = card.querySelector('[data-sg-description]')?.textContent || '';
        const descriptionTarget = this.querySelector('[data-sg-dialog-description]');
        descriptionTarget.textContent = description;
        descriptionTarget.hidden = !description;
        const link = card.querySelector('[data-sg-link]');
        const linkTarget = this.querySelector('[data-sg-dialog-link]');
        linkTarget.hidden = !link;
        if (link) {
          linkTarget.href = link.href;
          linkTarget.textContent = link.textContent;
        } else linkTarget.removeAttribute('href');
        this.querySelector('[data-sg-viewer-prev]').disabled = index === 0;
        this.querySelector('[data-sg-viewer-next]').disabled = index === this.cards.length - 1;
        this.querySelector('[data-sg-viewer-status]').textContent = this.dataset.viewerLabel
          .replace('TITLE', title).replace('POSITION', index + 1).replace('TOTAL', this.cards.length);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
